// third-party
import {FormattedMessage} from 'react-intl';

// assets
import { WarningOutlined, ToolOutlined, ThunderboltOutlined, UnorderedListOutlined } from '@ant-design/icons';

// type
import {NavItemType} from 'layout/mantis/types/MenuType';
import useAuthContext from 'context/useAuthContext';

// icons
const icons = {
    warningOutlined: WarningOutlined,
    toolOutlined: ToolOutlined,
    thunderboltOutlined: ThunderboltOutlined,
    unorderedListOutlined: UnorderedListOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function DiagnosticsMenuItems() {
    const {permissions, roles} = useAuthContext();
    let items: NavItemType = {};

    if(permissions) {

        items = {
            id: 'group-diagnostics',
            title: 'Diagnostics',
            type: 'group',
            children: []
        };

        items.children.push({
            id: 'core-diagnostics-errors',
            title: 'Errors',
            type: 'item',
            url: '/app/diagnostics/errors',
            icon: icons.thunderboltOutlined,
            breadcrumbs: false
        });

        items.children.push({
            id: 'core-diagnostics-warnings',
            title: 'Warnings',
            type: 'item',
            url: '/app/diagnostics/warnings',
            icon: icons.warningOutlined,
            breadcrumbs: false
        });

        items.children.push({
            id: 'core-diagnostics-log',
            title: 'Log',
            type: 'item',
            url: '/app/diagnostics/log',
            icon: icons.unorderedListOutlined,
            breadcrumbs: false
        });

    }

    return items;
}
